import { get } from 'lodash'

export default function(fields, photoUrl = null) {
  return {
    ...fields,
    picture: undefined,
    photoUrl: photoUrl || get(fields, 'photoUrl'),
    address: {
      ...fields.address,
      id: undefined,
      deleted: undefined
    }
  }
}
